import React from "react";
import "../styles/common.css";

/**
 * Composant réutilisable pour les boutons modernes
 * @param {string} variant - Type de bouton: 'primary' | 'secondary' | 'danger'
 * @param {ReactNode} icon - Icône à afficher
 * @param {string} children - Texte du bouton
 * @param {boolean} disabled - Si le bouton est désactivé
 * @param {function} onClick - Fonction de callback
 * @param {string} type - Type HTML du bouton (button, submit, etc.)
 * @param {string} className - Classes CSS additionnelles
 */
export default function ModernButton({
  variant = "primary",
  icon,
  children,
  disabled = false,
  onClick,
  type = "button",
  className = "",
}) {
  const variantClass = `modern-button-${variant}`;
  
  return (
    <button
      type={type}
      className={`modern-button ${variantClass} ${className}`}
      disabled={disabled}
      onClick={onClick}
    >
      {icon && icon}
      {children && <span>{children}</span>}
    </button>
  );
}

